<template>
	<div class="costs-summary-table">
		<costs-summary-title :module-number="moduleNumber" :number-of-modules="numberOfModules"
			:show-print-info="showPrintInfo"/>

		<costs-summary-headers/>

		<costs-summary-row
			text="Z dotacji"
			:value="formatMoney(costsSummary.dotation)"
			:index="1"
		></costs-summary-row>

		<costs-summary-row
			text="Inne środki finansowe ogółem"
			:index="2"
			:value="formatMoney(financialContribution)"
		></costs-summary-row>

		<costs-summary-sub-row
			text="Środki finansowe własne"
			:index="2.1"
			:value="formatMoney(costsSummary.ownFinancialContribution)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Świadczenia pieniężne od odbiorców"
			:index="2.2"
			:value="formatMoney(costsSummary.moneyFromRecipients)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Środki finansowe z innych źródeł publicznych"
			:index="2.3"
			:value="formatMoney(costsSummary.otherPublicSource)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Pozostałe"
			:index="2.4"
			:value="formatMoney(costsSummary.other)"
		></costs-summary-sub-row>

		<costs-summary-row
			text="Wkład osobowy i rzeczowy ogółem"
			:index="3"
			:value="formatMoney(ownContribution)"
		></costs-summary-row>

		<costs-summary-sub-row
			text="Wkład osobowy"
			:index="3.1"
			:value="formatMoney(costsSummary.ownHumanContribution)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Wkład rzeczowy"
			:index="3.2"
			:value="formatMoney(costsSummary.ownContributionInKind)"
		></costs-summary-sub-row>

		<costs-summary-row
			text="Ogółem"
			:index="4"
			:value="formatMoney(totalCosts)"
		></costs-summary-row>

		<costs-summary-row
			text="Udział wkładu własnego w stosunku do kwoty dotacji"
			:index="5"
			:isPercentage="true"
			:value="totalContributionToDotationPercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział kwoty dotacji w całkowitych kosztach"
			:index="6"
			:isPercentage="true"
			:value="dotationToWholePercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział innych środków finansowych w stosunku do kwoty dotacji"
			:index="7"
			:isPercentage="true"
			:value="financialContributionToDotationPercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział wkładu osobowego i wkładu rzeczowego w stosunku do kwoty dotacji"
			:index="8"
			:isPercentage="true"
			:value="ownContributionToDotationPercentage"
		></costs-summary-row>

		<div
			v-for="error in errors"
			:key="error"
		>
			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</div>
	</div>
</template>

<script>

	import CostsSummaryRow from "@/view/logged/offer/components/CostsSummaryRow";
	import CostsSummaryHeaders from "@/view/logged/offer/components/CostsSummaryHeaders";
	import CostsSummaryTitle from "@/view/logged/offer/components/CostsSummaryTitle";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
	import {Numbers} from "@/utils/Numbers";
	import CostsSummarySubRow from "@/view/logged/offer/components/CostsSummarySubRow";

	export default {
		name: "CostsSummaryTable",
		components: {
			EgrantyValidationError,
			CostsSummaryTitle,
			CostsSummaryHeaders,
			CostsSummaryRow,
			CostsSummarySubRow,
		},
		computed: {

			totalContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.totalContribution, this.costsSummary.dotation);
			},

			ownContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.ownContribution, this.costsSummary.dotation);
			},

			financialContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.financialContribution, this.costsSummary.dotation);
			},

			dotationToWholePercentage() {
				return Numbers.methods.formatPercentage(this.costsSummary.dotation, this.totalCosts);
			},
		},

		mounted() {
			
			// Pobranie danych oferty
			this.costsSummary  = {
                    "dotation": 0.0000,
                    "administrative": 0.0000,
                    "ownFinancialContribution": 0,
                    "ownContributionInKind": 0,
                    "ownHumanContribution": 0,
                    "moneyFromRecipients": 0,
                    "other": 0,
                    "otherPublicSource": 0
                };
							this.financialContribution = 0;
							this.ownContribution = 0;
							this.totalContribution = 0;
							this.totalCosts = 0;
							this.firstModuleCostsSummary = 0;
							this.firstModuleTotalCosts = 0;
		},

		methods: {

		},

		data() {
			return {
				errors: [],
				financialSettings: undefined,
				countrySettings: undefined,
			financialLimits: undefined,
			moduleFinancialPercentageConfig: undefined,
			costsSummary :{},
			financialContribution : 0,
			ownContribution : 0,
			totalContribution : 0,
			totalCosts : 0,
			firstModuleCostsSummary: {},
			firstModuleTotalCosts: 0,
			};
		},


		props: {
			offerDataId: {},
			offerConfiguration: Object,
			mainCountryId: {},
			mainBidderId: {},
			contestId: {},
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},

		mixins: [
			Numbers,
		],
	};
</script>

<style scoped>

</style>